module.exports = __webpack_public_path__ + "img/right.ea22ee09.png";